import history from '../../../../../history'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { SearchListing } from '../../../../../types/listings'
import { PATH_HELPERS } from '../../../../../constants/navigation'
import { useEffect, useRef, Ref, useState } from 'react'
import { ListingCard } from '../../../ListingCard'
import { selectSelectedListingId } from '../../../../../store/selectors/listings'

import styles from './ListViewItem.module.scss'

export interface ListingDispatchParams {
  type: string
  listing: SearchListing
  ref: Ref<HTMLDivElement>
}

export interface ListViewItemProps {
  customerId: string
  listing: SearchListing
  assignListingRef: string
  handleHoverAndFocusChange: (listingId: string | undefined | null) => void
  listingsDispatch: ({ type, listing, ref }: ListingDispatchParams) => void
}

export const ListViewItem = ({
  handleHoverAndFocusChange,
  listing,
  customerId,
  assignListingRef,
  listingsDispatch,
}: ListViewItemProps) => {
  const ref = useRef(null)
  const [isTouchMoving, setIsTouchMoving] = useState(false)
  const selectedListingId = useSelector(selectSelectedListingId)
  const listingUrl = PATH_HELPERS.listing.buildPath(customerId, listing.id)

  useEffect(() => {
    listingsDispatch({
      type: assignListingRef,
      listing: listing,
      ref: ref,
    })
  }, [assignListingRef, listing, listingsDispatch])

  return (
    <li tabIndex={-1}>
      <Link
        tabIndex={0}
        to={listingUrl}
        className={styles.link}
        onMouseLeave={() => handleHoverAndFocusChange(null)}
        onFocus={() => handleHoverAndFocusChange(listing?.id)}
        onMouseEnter={() => handleHoverAndFocusChange(listing?.id)}
        onTouchMove={() => setIsTouchMoving(true)}
        onTouchEnd={() =>
          isTouchMoving ? setIsTouchMoving(false) : history.push(listingUrl)
        }
      >
        <ListingCard
          ref={ref}
          listing={listing}
          focused={listing.id === selectedListingId}
        />
      </Link>
    </li>
  )
}
